import Vue from 'vue'
import _ from 'lodash';
import Inputmask from "inputmask";

Vue.directive('mask3', {
    bind: function (el, binding) {

        if (!binding.value) {
            return;
        }
        Inputmask(_.extend(binding.value, {
            showMaskOnHover: true,
            autoUnmask: true
        })).mask(el.querySelector("input"));
    },
    unbind: function (el) {
        if (el.querySelector("input").inputmask)
            el.querySelector("input").inputmask.remove()
    }
});

